/**
 * Configurable per-role labor rates (admin-editable). The intake estimate
 * reads `estimate_default`; the admin rate editor writes the table.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { LaborRates, LaborRatesUpdate } from '@vari-crew/schemas';
import { apiCall } from '@/lib/api';

const KEY = ['labor-rates'] as const;

/** Supervisor/admin only (PMs don't see the estimate, so they don't fetch). */
export function useLaborRates(enabled = true) {
  return useQuery<LaborRates>({
    queryKey: KEY,
    enabled,
    queryFn: () => apiCall<LaborRates>('/labor-rates'),
    staleTime: 5 * 60 * 1000,
  });
}

export function useUpdateLaborRates() {
  const qc = useQueryClient();
  return useMutation<LaborRates, Error, LaborRatesUpdate>({
    mutationFn: (body) => apiCall<LaborRates>('/labor-rates', { method: 'PUT', body }),
    onSuccess: (rates) => qc.setQueryData(KEY, rates),
  });
}
